// Who may download outright, without a request. Mirrors the server's rulebook
// (BE controllers/downloadAuth.js, rules 1–2): staff roles and full-access
// users. Everyone else — and anonymous — goes through a download request.
// Role names here are the FE display names (state.masterData.userData
// .roleDisplayName), not the server's upper-case role.name values.
const STAFF_ROLES = ['Admin', 'Super_admin', 'APPROVER'];

export function canDownloadDirectly(userData) {
    if (!userData) return false;
    return userData.hasFullAccess === true || STAFF_ROLES.includes(userData.roleDisplayName);
}
